import { render, staticRenderFns } from "./Signout.vue?vue&type=template&id=a0764fc0"
import script from "./Signout.vue?vue&type=script&lang=js"
export * from "./Signout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/bamboo-agent-home/xml-data/build-dir/MEM-MEMUI-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0764fc0')) {
      api.createRecord('a0764fc0', component.options)
    } else {
      api.reload('a0764fc0', component.options)
    }
    module.hot.accept("./Signout.vue?vue&type=template&id=a0764fc0", function () {
      api.rerender('a0764fc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/detail-card/Signout.vue"
export default component.exports